export default __webpack_public_path__ + "static/media/classes_sel.078b77e5.svg";